export enum DockType {
  Loading = 'LOADING',
  Unloading = 'UNLOADING',
}

export const CLONE_DOCK_NAME_SUFFIX = '_copy';
